import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getPendingPaymentList(_, payload) {
    return axios
      .get("/api/payment/invoice-pending-listing", {
        params: payload,
      })
      .then((res) => res.data);
  },
  updatePendingPaymentDetails(_, payload) {
    return axios
      .post(`/api/payment/invoice-update`, payload)
      .then((res) => res.data);
  },
  getBankTransferList(_, payload) {
    return axios
      .get("/api/payment/bank-list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getPaymentGatewayList(_, payload) {
    return axios
      .get("/api/payment/payment-gateway-list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadPendingPayment(context, payload) {
    return axios
      .post(`/api/payment-pending/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  getPaymentList(_, payload) {
    return axios
      .get(`/api/payment/payment-list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadPaymentList(context, payload) {
    return axios
      .post(`/api/payment-transaction/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  carrierCodList(context, payload) {
    return axios
      .get(`/api/carrier_cod_payment/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  rsaCodList(context, payload) {
    return axios
      .get(`/api/client_cod_payment/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  pendingCodList(context, payload) {
    return axios
      .get(`/api/cod_payment_pending/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  paidCodList(context, payload) {
    return axios
      .get(`/api/cod_payment_paid_summary/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadDispute(context, data) {
    return axios
      .get(`/api/cod_disputed_payment/download?flag=${data.type}`, {
        responseType: "blob",
        params: data,
      })
      .then((res) => res);
  },
  pendingCodOrderList(context, payload) {
    return axios
      .get(`/api/cod_pending_order/list?flag=${payload.type}`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadPendingAction(_, payload) {
    return axios
      .get(`/api/cod_pending_order/download?flag=${payload.type}`, {
        params: payload,
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadCarrierData(context, id) {
    return axios
      .get(`/api/cod/transaction_orders/download/${id}?flag=carrier`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadRsaData(context, id) {
    return axios
      .get(`/api/cod/transaction_orders/download/${id}?flag=rsa`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadReconciliationList(context, payload) {
    return axios
      .get(`/api/cod_pending_order/download?flag=carrier`, {
        responseType: "blob",
        params: payload,
      })
      .then((res) => res);
  },
  disputedCodList(context, data) {
    return axios
      .get(`/api/cod_disputed_order/list?flag=${data.type}`, {
        params: data,
      })
      .then((res) => res.data);
  },

  orderDetails(_, data) {
    return axios
      .get(`/api/transaction_orders/list/${data.id}?flag=${data.type}`, {
        params: data.options,
      })
      .then((res) => res.data);
  },
  addRsaCodList(_, data) {
    return axios
      .post(`/api/client_cod_payment/create/${data.id}`, data.payload)
      .then((res) => res.data);
  },
  addRsaInitiateOrder(_, payload) {
    return axios
      .post(`/api/rsa_initiate_payment/create`, payload)
      .then((res) => res.data);
  },
  addCarrierCod(_, payload) {
    return axios
      .post(`/api/carrier_cod_payment/create`, payload)
      .then((res) => res.data);
  },
  getTransactionList(_, type) {
    return axios
      .get(`/api/transaction_number/list/${type}`)
      .then((res) => res.data);
  },
  rejectPayment(_, id) {
    return axios
      .get(`/api/reject_initiate_payment/${id}`)
      .then((res) => res.data);
  },
  uploadCodList(_, payload) {
    return axios
      .post(`/api/order_summary/upload`, payload)
      .then((res) => res.data);
  },
  updateOrderDetails(_, payload) {
    return axios
      .patch(`/api/carrier_cod_payment/update/${payload.id}`, payload.params)
      .then((res) => res.data);
  },
  updateCarrierCod(_, payload) {
    return axios
      .patch(`/api/cod_payment/update/${payload.id}`, payload.params)
      .then((res) => res.data);
  },
  downloadRsaTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=COD_reconcile/templates/rsa_cod_order_excel_template.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  downloadCarrierTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=COD_reconcile/templates/carrier_cod_order_excel_template.xlsx`,

        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
